import { Component, OnInit } from '@angular/core';
import ProyectoService from '../../services/proyecto.service';

@Component({
  selector: 'app-trabajos',
  templateUrl: './trabajos.component.html',
  styleUrls: ['./trabajos.component.css']
})
export class TrabajosComponent implements OnInit {

  proyectos: Array<any>;

  constructor(private proyectServ: ProyectoService) { }

  ngOnInit() {
    this.proyectServ.obtenerProyectos().subscribe(result=>{
      this.proyectos = result;
      console.log(this.proyectos);
    })
  }

}
